import Vue from 'vue';

export default {
  install: function() {
    Vue.prototype.$mensagemErro = function(erro, titulo = 'Erro na requisição.') {
      if (erro.message === 'validacao') return;

      if ((erro.msg && erro.msg === "[vee-validate]: Validation Failed") || (erro.message && erro.message === "validacao com erro")) {
        this.$swal(
          '',
          `Há campos que são obrigatórios e não foram prenchidos, por favor confira os campos em vermelho.`,
          'info'
        );

        return;
      }

      if (erro.status === 422 && Array.isArray(erro.body) && erro.body.some(e => e && e.mensagem)) {
        this.$swal(
          '',
          erro.body.filter(e => e && e.mensagem).map(e => e.mensagem).join('<br>'),
          'warning'
        );

        return;
      }

      let mensagem = '';

      if (erro.status === 500 || erro.status === 400) {
        mensagem = erro.body;
      } else if (!erro.status) {
        mensagem = erro;
      }

      this.$swal(
        '',
        `${titulo} <br> 
         Caso o erro persista entre em contato com a fundação.
         ${Vue.config.productionTip ? mensagem : ''}`,
        'error'
      );
    }
  }
}



// WEBPACK FOOTER //
// ./FrontEnd/plugins/mensagem-erro.js